"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routeInfoView = exports.assetInfoView = exports.zoomRouteView = void 0;

var _utils = require("../../utils");

var _color = require("../../utils/color");

var _units = require("../../utils/units");

var _utils2 = require("./utils");

var _DOM = _interopRequireDefault(require("../../display/DOM"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var handleGoToMarker = function (event, handler) {
  var $el = (0, _DOM.default)(event.currentTarget);
  var coord = $el.data('coord');
  var type = $el.data('waypoint-type');

  if (!(0, _utils.isEmpty)(coord)) {
    var _a = coord.split(','),
        lat = _a[0],
        lon = _a[1];

    if ((0, _utils.isset)(handler)) {
      handler({
        coordinate: {
          lat: lat,
          lon: lon
        },
        type: type
      });
    }
  }
};

var zoomRouteView = function (onClick) {
  return {
    id: 'zoom',
    static: true,
    renderer: function () {
      return "\n\t\t<div class=\"awxjs__ui-btn awxjs__ui-btn-default awxjs__ui-btn-full awxjs__btn-routing-zoom\">\n\t\t\tZoom to Route\n\t\t</div>\n\t";
    },
    init: function (view) {
      view.el('.awxjs__btn-routing-zoom').on('click', function () {
        if (onClick) {
          onClick();
        }
      });
    }
  };
};

exports.zoomRouteView = zoomRouteView;

var assetInfoView = function (onViewClick) {
  return {
    id: 'asset',
    requiresData: true,
    init: function (view) {
      view.on('render', function () {
        view.el('.awxjs__ui-btn-goto').on('click', function (e) {
          handleGoToMarker(e, onViewClick);
        });
      });
    },
    data: function (data) {
      return (0, _utils.get)(data, 'route.asset');
    },
    renderer: function (data) {
      var title = data.title,
          description = data.description,
          imageUrl = data.imageUrl,
          status = data.status,
          loc = data.loc;
      var badgeColor = (0, _utils.get)(status, 'color');
      var badgeTextColor = (0, _color.isLight)(badgeColor) ? '#333' : '#fff';
      var badgeStyles = "background-color: " + badgeColor + "; color: " + badgeTextColor;
      var dataAttr = ["data-waypoint-type=\"current\""];

      if ((0, _utils.isset)(loc)) {
        dataAttr.push("data-coord=\"" + loc.lat + "," + loc.lon + "\"");
      }

      return "\n\t\t\t<div class=\"awxjs__ui-cols\">\n\t\t\t\t<div class=\"awxjs__text-xl awxjs__text-bold awxjs__push-bottom awxjs__ui-expand\">\n\t\t\t\t\t" + title + "\n\t\t\t\t</div>\n\t\t\t\t" + ((0, _utils.isset)(loc) ? "\n\t\t\t\t\t<div class=\"awxjs__right\">\n\t\t\t\t\t\t<div class=\"awxjs__ui-btn-icon awxjs__ui-btn-icon-filled awxjs__ui-btn-goto\" " + dataAttr.join(' ') + " title=\"Zoom to location\">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\">\n\t\t\t\t\t\t\t\t<path d=\"M50,0C30.9,0,15.6,15.3,15.6,34.4C15.6,53.4,50,100,50,100s34.4-46.6,34.4-65.6C84.4,15.3,69.1,0,50,0z M50,50\n\t\t\t\t\t\t\t\t\tc-8.7,0-15.6-6.9-15.6-15.6c0-8.7,6.9-15.6,15.6-15.6c8.7,0,15.6,6.9,15.6,15.6C65.6,43.1,58.7,50,50,50z\"/>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t" : '') + "\n\t\t\t</div>\n\t\t\t<div class=\"awxjs__routing-asset__details\">\n\t\t\t\t<div class=\"awxjs__ui-cols\">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t" + ((0, _utils.isset)(status) ? "\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row awxjs__ui-expand\">\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand label\">Status</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__ui-expand value\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__routing-asset__details-status\" style=\"" + badgeStyles + "\">\n\t\t\t\t\t\t\t\t\t\t" + (0, _utils.get)(status, 'label') + "\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t\t" + (description ? "\n\t\t\t\t\t\t\t<div class=\"awxjs__routing-asset__details-desc awxjs__text-sm awxjs__push-top\">\n\t\t\t\t\t\t\t\t" + description + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t" : '') + "\n\t\t\t\t\t</div>\n\t\t\t\t\t" + (imageUrl ? "\n\t\t\t\t\t\t<div class=\"awxjs__routing-asset__details-image\">\n\t\t\t\t\t\t\t<img src=\"" + (0, _utils.get)(data, 'imageUrl') + "\" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t" : '') + "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
    }
  };
};

exports.assetInfoView = assetInfoView;

var routeInfoView = function (onViewClick) {
  return {
    id: 'route',
    requiresData: true,
    init: function (view) {
      view.on('render', function () {
        view.el('.awxjs__ui-btn-goto').on('click', function (e) {
          handleGoToMarker(e, onViewClick);
        });
      });
    },
    data: function (data) {
      if (!(0, _utils.get)(data, 'route.departure') || !(0, _utils.get)(data, 'route.destination')) {
        return undefined;
      }

      var _a = (0, _utils.get)(data, 'route') || {},
          departure = _a.departure,
          destination = _a.destination,
          _b = _a.waypoints,
          waypoints = _b === void 0 ? [] : _b,
          distanceMeters = _a.distanceMeters,
          durationSeconds = _a.durationSeconds;

      var departureWeather = (0, _utils.get)(data["forecasts_" + departure.id], '0.periods.0');
      var destinationWeather = (0, _utils.get)(data["forecasts_" + destination.id], '0.periods.0');
      return (0, _utils.extend)({}, data, {
        route: {
          distance: (0, _utils.isset)(distanceMeters) ? {
            distanceMI: distanceMeters * 0.00062,
            distanceKM: distanceMeters * 0.001
          } : undefined,
          duration: durationSeconds || 0,
          departure: {
            weather: departureWeather
          },
          destination: {
            weather: destinationWeather
          }
        }
      });
    },
    request: function (account, data) {
      var _a = data || {},
          departure = _a.departure,
          destination = _a.destination,
          _b = _a.durationSeconds,
          durationSeconds = _b === void 0 ? 0 : _b;

      var request = account.api();
      var startTimestamp = Date.now();

      if (departure) {
        var loc = departure.loc,
            _c = departure.timestamp,
            timestamp = _c === void 0 ? startTimestamp : _c;

        if (loc) {
          var lat = loc.lat,
              lon = loc.lon;
          var req = account.api();

          var _d = (0, _utils2.configureForecastRequest)(req, lat + "," + lon, timestamp),
              forecastRequest = _d.request,
              date = _d.date;

          request.addRequest(forecastRequest);

          if (date) {
            startTimestamp = date.getTime();
          }
        }
      }

      if (destination) {
        var loc = destination.loc,
            _e = destination.timestamp,
            timestamp = _e === void 0 ? startTimestamp + durationSeconds * 1000 : _e;

        if (loc) {
          var lat = loc.lat,
              lon = loc.lon;
          var req = account.api();
          var forecastRequest = (0, _utils2.configureForecastRequest)(req, lat + "," + lon, timestamp).request;
          request.addRequest(forecastRequest);
        }
      }

      return request;
    },
    renderer: function (data) {
      var metric = data.units === "metric"
      /* Metric */
      ;

      var _a = (0, _utils.get)(data, 'route') || {},
          departure = _a.departure,
          destination = _a.destination,
          _b = _a.waypoints,
          waypoints = _b === void 0 ? [] : _b,
          distance = _a.distance,
          duration = _a.duration,
          selectedIndex = _a.selectedIndex; // console.log(data);


      var startLocation = (0, _utils2.renderLocation)('major', __assign(__assign({}, departure), {
        indicator: 'A',
        type: 'start',
        timeLabel: 'Departing',
        selected: selectedIndex === 'start',
        metric: metric
      }), duration > 0);
      var endLocation = (0, _utils2.renderLocation)('major', __assign(__assign({}, destination), {
        indicator: 'B',
        type: 'end',
        timeLabel: 'Arriving',
        selected: selectedIndex === 'end',
        metric: metric
      }), duration > 0);
      var waypointLocations = waypoints.length > 0 ? "<div class=\"awxjs__routing-waypoints\">\n\t\t\t" + waypoints.map(function (waypoint, index) {
        return (0, _utils2.renderLocation)('waypoint', __assign(__assign({}, waypoint), {
          type: 'waypont',
          selected: index === selectedIndex
        }));
      }).join('\n') + "\n\t\t\t\t</div>" : '';
      return "\n\t\t\t" + ((0, _utils.isset)(distance) && distance.distanceMI > 0 ? "\n\t\t\t\t<div class=\"awxjs__text-md awxjs__push-bottom\">\n\t\t\t\t\t<strong>" + (0, _units.formatDataValue)(distance, 'distanceMI', 'distanceKM', metric) + "</strong>\n\t\t\t\t\t" + (duration > 0 ? " - " + (0, _units.secondsToString)(duration) : '') + "\n\t\t\t\t</div>\n\t\t\t" : '') + "\n\t\t\t<div class=\"awxjs__routing-route\">\n\t\t\t\t<div class=\"awxjs__routing-track" + (duration > 0 ? ' awxjs__routing-track-tall' : '') + "\">\n\t\t\t\t\t<svg width=\"10px\" height=\"300px\" viewBox=\"0 0 10 300\">\n\t\t\t\t\t\t<line x1=\"5\" x2=\"5\" y1=\"0\" y2=\"300\" stroke=\"#ccc\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-dasharray=\"1,6\"/>\n\t\t\t\t\t</svg>\n\t\t\t\t</div>\n\t\t\t\t" + startLocation + "\n\t\t\t\t" + waypointLocations + "\n\t\t\t\t" + endLocation + "\n\t\t\t</div>\n\t\t";
    }
  };
};

exports.routeInfoView = routeInfoView;